import qs from 'qs';

export class RoutePaths {
  static login = {
    path: 'login',
    onNavigate: () => '/login',
  };

  static recovery = {
    path: 'recovery',
    onNavigate: () => '/recovery',
  };
  static recoveryUsername = {
    path: 'username',
    onNavigate: () => '/recovery/username',
  };
  static recoveryPassword = {
    path: 'password',
    onNavigate: () => '/recovery/password',
  };

  static applyNow = {
    path: 'apply-now',
    onNavigate: () => '/apply-now',
  };

  static dashboard = {
    path: 'dashboard',
    onNavigate: () => '/dashboard',
  };

  static accounts = {
    path: 'accounts/:id',
    onNavigate: (id: string) => `/accounts/${id}`,
  };

  static cards = {
    path: 'cards',
    onNavigate: () => '/cards',
  };

  static payments = {
    path: 'payments',
    onNavigate: () => '/payments',
  };

  static contactUs = {
    path: 'contact-us',
    onNavigate: () => '/contact-us',
  };

  static messages = {
    path: 'messages/:dir/:id?',
    onNavigate: (params: { dir: 'inbox' | 'sent'; id?: string }, query?: { q?: string; from?: string; to?: string; queryString?: string }) => {
      const { queryString, ...rest } = query ?? {};
      const search = queryString ? queryString : qs.stringify(rest, { addQueryPrefix: true });
      return `/messages/${params.dir}${params.id ? `/${params.id}` : ''}${search}`;
    },
  };
}
